var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowStraightGraph01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1125 675",
    style: {
      enableBackground: "new 0 0 1125 675"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.4,326c150.2-0.4,96.3-1,246.6-1.3c337.7-0.7,446.2-1.3,783.9-2c4.3,0,8.7,0,16.6,0c-18.1-21.1-33.9-39.5-50.7-59 c4.9-4,9.3-7.7,15.3-12.6c24.6,27.3,48.6,54,73.4,81.6c-26.2,27.6-51.7,54.4-78.1,82.1c-4.5-5.6-8.1-10.2-12.3-15.4 c16.9-18.8,33.3-37.1,51.6-57.5c-6.7-0.4-11.3-0.8-15.9-0.8c-339.2,1.4-449.2,2.9-788.4,4.3c-148.7,0.6-93.3,1.1-242.1,1.7 C25.4,340.1,25.4,333.1,25.4,326z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowStraightGraph01);
export default __webpack_public_path__ + "static/media/arrow-straight-graph-01.8920b979847bb33d1e696132f1244053.svg";
export { ForwardRef as ReactComponent };